import React from 'react';

import { DialCodes } from '@nw/shared/data-access';

import { MultiStepOtpHeadingProps } from '../../types/MultiStepRegistrationFormTypes';

import { OTPDescriptionText, PhoneNumberText } from './styledComponents';

export const MultiStepOtpHeading: React.FC<MultiStepOtpHeadingProps> = ({
  phoneValue,
  t
}) => {
  return (
    <OTPDescriptionText className={'OTPDescriptionTextClassName'}>
      {t('login.weHaveSentOTPtoYourMobileNumber')}
      <PhoneNumberText className={'phoneNumberTextClassClassName'}>
        {` ${DialCodes.india}`}&nbsp;{phoneValue}
      </PhoneNumberText>
    </OTPDescriptionText>
  );
};
